import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=513b7456&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=ts"
export * from "./Form2.vue?vue&type=script&lang=ts"
import style0 from "./Form2.vue?vue&type=style&index=0&id=513b7456&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b7456",
  null
  
)

export default component.exports